"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardBackspaceIconMobileStyled = exports.GridStyled = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const KeyboardBackspace_1 = __importDefault(require("@material-ui/icons/KeyboardBackspace"));
exports.Container = styled_components_1.default(core_1.Grid) `
  background-color: ${({ fundoTransparatente }) => fundoTransparatente ? 'transparent' : 'white'};
  padding-left: 8px;
  padding-right: 8px;
`;
exports.GridStyled = styled_components_1.default(core_1.Grid) `
  width: calc(100% - 30px);
`;
exports.KeyboardBackspaceIconMobileStyled = styled_components_1.default(KeyboardBackspace_1.default) `
  width: 30px;
  height: 25px;
  color: #a5a7a6;
`;
//# sourceMappingURL=styles.js.map